module.exports = __webpack_public_path__ + "img/lens-167-minus-05.a85b2516.png";